// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MemoPlay$LiteracyplanetClientFlags from "./MemoPlay.res.mjs";

function AudioButtonApi(props) {
  var onTogglePlay = props.onTogglePlay;
  var onEnd = props.onEnd;
  var src = props.src;
  var isPlaying = props.isPlaying;
  var match = React.useState(function () {
        if (isPlaying) {
          return "Loading";
        } else {
          return "Stopped";
        }
      });
  var setState = match[1];
  var match$1 = React.useState(function () {
        return "NothingCalled";
      });
  var setEvent = match$1[1];
  var $$event = match$1[0];
  React.useEffect((function () {
          var exit = 0;
          if (isPlaying) {
            switch ($$event) {
              case "NothingCalled" :
                  setState(function (param) {
                        return "Loading";
                      });
                  break;
              case "ToggleCalled" :
                  setState(function (param) {
                        return "Loading";
                      });
                  break;
              case "PlayingCalled" :
              case "LoadedCalled" :
                  exit = 2;
                  break;
              case "EndedCalled" :
                  exit = 1;
                  break;
              
            }
          } else {
            switch ($$event) {
              case "ToggleCalled" :
                  setState(function (param) {
                        return "Stopped";
                      });
                  break;
              case "EndedCalled" :
                  exit = 1;
                  break;
              default:
                exit = 2;
            }
          }
          switch (exit) {
            case 1 :
                setState(function (param) {
                      return "Stopped";
                    });
                break;
            case 2 :
                if (isPlaying) {
                  setState(function (param) {
                        return "Playing";
                      });
                } else {
                  setState(function (param) {
                        return "Stopped";
                      });
                }
                break;
            
          }
        }), [
        isPlaying,
        $$event
      ]);
  var onPlaying = function (param) {
    setEvent(function (param) {
          return "PlayingCalled";
        });
  };
  var onLoaded = function (param) {
    setEvent(function (param) {
          return "LoadedCalled";
        });
  };
  var toggle = function () {
    onTogglePlay();
    setEvent(function (param) {
          return "ToggleCalled";
        });
  };
  var ended = function () {
    onEnd();
    setEvent(function (param) {
          return "EndedCalled";
        });
  };
  return React.createElement(React.Fragment, {}, props.children(match[0], toggle), isPlaying && src !== undefined ? React.createElement(MemoPlay$LiteracyplanetClientFlags.make, {
                    src: src,
                    onEnd: ended,
                    onLoaded: onLoaded,
                    onPlaying: onPlaying
                  }) : null);
}

var make = AudioButtonApi;

export {
  make ,
}
/* react Not a pure module */
